module.exports = __webpack_public_path__ + "img/hall_contactanos.8caebeda.jpg";